<template>
  <layout title="Login">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Login</div>

          <div class="card-body">
            <div v-if="errors.username" class="alert alert-danger">
              {{ errors.username }}
            </div>

            <div v-if="session_status" class="alert alert-success">
              {{ session_status }}
            </div>

            <form method="POST" action="/login" @submit.prevent="submit">
              <div class="form-group row">
                <label for="username" class="col-md-4 col-form-label text-md-right"
                  >Username</label
                >

                <div class="col-md-6">
                  <input
                    id="username"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.username }"
                    name="username"
                    required
                    autocomplete="username"
                    autofocus
                    v-model="form.username"
                  />
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="password"
                  class="col-md-4 col-form-label text-md-right"
                  >Password</label
                >

                <div class="col-md-6">
                  <input
                    id="password"
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': errors.username }"
                    name="password"
                    required
                    autocomplete="current-password"
                    v-model="form.password"
                  />
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-6 offset-md-4">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="remember"
                      id="remember"
                    />
                    <label class="form-check-label" for="remember">
                      Remember Me
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                  <button type="submit" class="btn btn-primary">Login</button>
                  <a class="btn btn-link" :href="route('password.request')">
                    Forgot Your Password?
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AuthLayout from "../Layouts/AuthLayout";

export default {
  layout: AuthLayout,
  props: {
    csrf_token: String,
    errors: Object,
    session_status: String
  },
  title: 'Login',
  data() {
    return {
      sending: false,
      form: {
        
      },
    };
  },
  methods: {
    submit() {
      const data = {
        username: this.form.username,
        password: this.form.password,
        remember: this.form.remember,
      };
      // this.$inertia.post("/login", data, {
      this.$inertia.post(route('login'), data, {
        onStart: () => (this.sending = true),
        onFinish: () => (this.sending = false),
      });
    },
  },
};
</script>